import { RefObject, useEffect } from 'react';

export const getDayColumnId = (index: number) => `week-view-day-column-${index}`;

const useScrollToDayColumn = (
    scrollRef: RefObject<HTMLDivElement>,
    dayIndex: number,
    layoutKey: string,
) => {
    useEffect(
        () => {
            const scrollElement = scrollRef.current;
            if (!scrollElement) {
                return;
            }

            // A week without today opens on its first day rather than keeping whatever
            // position the previously displayed week was left at.
            if (dayIndex < 0) {
                scrollElement.scrollLeft = 0;
                return;
            }

            const column = scrollElement.querySelector<HTMLElement>(
                `#${getDayColumnId(dayIndex)}`,
            );
            if (!column) {
                return;
            }

            // Columns are not all the same width once empty days collapse, so measure
            // instead of multiplying an index by a fixed column width.
            const columnRect = column.getBoundingClientRect();
            const scrollRect = scrollElement.getBoundingClientRect();
            const { clientWidth, scrollLeft } = scrollElement;
            const left = (columnRect.left - scrollRect.left) + scrollLeft;
            const centered = (left + (columnRect.width / 2)) - (clientWidth / 2);

            scrollElement.scrollLeft = Math.max(0, centered);
        },
        [dayIndex, layoutKey, scrollRef],
    );
};

export default useScrollToDayColumn;
